import { ChiroUpAPI } from '@chiroup/client-core/functions/ChiroUpAPI';
import { GLOBAL_MANY_IDS_SEP } from '@chiroup/core/constants/globals';
import { Modalities } from '@chiroup/core/types/Modalities.type';

const modalityService = () => {
  const list = async (
    clinicId: number,
    ids: number[] = [],
    getReferenceCodes = false,
    includeIds?: number[]
  ): Promise<{ data: Modalities[] }> => {
    return ChiroUpAPI.get('api', `/${clinicId}/modality`, {
      queryParams: {
        ids: ids?.length ? ids : undefined,
        getReferenceCodes: getReferenceCodes ? 'true' : undefined,
        includeIds: includeIds?.length ? includeIds.join(',') : undefined,
      },
    });
  };

  /**
   * This differs fromo the 'list' above in that it returns the reference codes
   * attached to each modality -- if any. It returns a singleton or an array of
   * singletons.
   *
   * @param clinicId
   * @param ids
   * @returns
   */
  const get = async (clinicId = -1, id: number): Promise<Modalities> => {
    if (id === -1) return {} as Modalities;

    return ChiroUpAPI.get('api', `/${clinicId}/modality/${id}`, {});
  };

  const getMany = async (clinicId = -1, ids: number[]): Promise<Modalities> => {
    const idsWithNoNegativeOne = ids.filter(id => String(id) !== '-1');
    if (idsWithNoNegativeOne.length === 0) return {} as Modalities;

    return ChiroUpAPI.get(
      'api',
      `/${clinicId}/modality/${idsWithNoNegativeOne.join(GLOBAL_MANY_IDS_SEP)}`,
      {}
    );
  };

  return {
    list,
    get,
    getMany,
  };
};

export default modalityService();
